import * as React from "react";
import { useStorageBackedState } from "../../utils/useStorageBackedState";

export interface AdminProps {
  showVpnTools: boolean;
  setShowVpnTools: (showVpnTools: boolean) => void;
}
export const AdminContext = React.createContext<AdminProps>(null);

export const AdminProvider = ({ children }: { children: React.ReactNode }) => {
  const [showVpnTools, setShowVpnTools] = useStorageBackedState<boolean>(
    "showVpnTools",
    false
  );

  const value = { showVpnTools, setShowVpnTools };

  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};

export function useShowVpnTools() {
  return React.useContext(AdminContext).showVpnTools && !!window.isLocalIp;
}
